import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /**
   * Invisible text that labels the Tooltip button
   */
  buttonLabelText: PropTypes.string.isRequired,
  /**
   * Content inside the Tooltip balloon
   */
  children: PropTypes.node.isRequired,
  /**
   * ID of the tooltip (required for a11y)
   */
  contentID: PropTypes.string.isRequired,
  /**
   * Controls how the Tooltip balloon opens relative to the control
   */
  contentPosition: PropTypes.oneOf(['bottom-left', 'bottom-center', 'bottom-right', 'top-center', 'top-left', 'top-right']).isRequired,
  /**
   * You will usually want to stop propagation on this event or it will close modals for example
   */
  onKeyUp: PropTypes.func.isRequired,
  /**
   * Controls the display of the Tooltip balloon
   */
  isOpen: PropTypes.bool,
  /**
   * Blur handler for the Tooltip button
   */
  onBlur: PropTypes.func,
  /**
   * Click handler for the Tooltip button
   */
  onClick: PropTypes.func,
  /**
   * Mouse leave handler for the Tooltip button
   */
  onMouseLeave: PropTypes.func
};

/**
 * The TooltipWidget requires manual activation. For more information, see [Tooltip Accessibility Pattern Details](https://hub.accessible360.com/kb/articles/524)
 */
function TooltipWidget(_ref) {
  var buttonLabelText = _ref.buttonLabelText,
    children = _ref.children,
    contentID = _ref.contentID,
    contentPosition = _ref.contentPosition,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? 'false' : _ref$isOpen,
    onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onKeyUp = _ref.onKeyUp,
    onMouseLeave = _ref.onMouseLeave;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tooltip-widget",
    "data-content-position": contentPosition,
    "data-open": isOpen,
    "data-testid": "tooltip-widget"
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-controls": contentID,
    "aria-expanded": isOpen,
    className: "tooltip-button",
    onBlur: onBlur,
    onClick: onClick,
    onKeyDown: onKeyUp,
    onMouseLeave: onMouseLeave,
    type: "button"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "screen-reader-text"
  }, buttonLabelText), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "tooltip-icon",
    "data-testid": "tooltip-icon"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "tooltip-content",
    id: contentID,
    role: "tooltip"
  }, children));
}
TooltipWidget.propTypes = propTypes;

export { TooltipWidget as default };
//# sourceMappingURL=TooltipWidget.js.map
